//@ts-nocheck
import React from 'react';
import { Button } from './common/inputs/Button';
import Modal from 'react-modal';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextField } from '@mui/material';

// <Faq questions={this.state.program.faq} onChange={this.onFaqChange} />
type QA = {
  question: string;
  answer: string;
};
type FaqProps = {
  faqSuggestions?: Array<QA>;
  questions: Array<QA>;
  onChange: any;
  tree: any;
};
class Faq extends React.Component<FaqProps> {
  constructor(props) {
    super(props);
    this.state = {
      questionPlaceholder: 'Question?',
      answerPlaceholder: 'Answer.',
      faqSuggestionsModal: false,
    };
    this.onChange = this.onChange.bind(this);
    this.moveUp = this.moveUp.bind(this);
    this.moveDown = this.moveDown.bind(this);
    this.delete = this.delete.bind(this);
    this.add = this.add.bind(this);
  }
  onChange(index, data) {
    let questions = this.props.questions.slice();
    questions[index] = data;
    this.props.onChange(questions);
  }
  moveUp(index) {
    if (index < 1) return;
    let questions = this.props.questions.slice();
    let t = questions[index];
    questions[index] = questions[index - 1];
    questions[index - 1] = t;
    this.props.onChange(questions);
  }
  moveDown(index) {
    if (index > this.props.questions.length - 1) return;
    let questions = this.props.questions.slice();
    let t = questions[index + 1];
    questions[index + 1] = questions[index];
    questions[index] = t;
    this.props.onChange(questions);
  }
  delete(index) {
    let questions = this.props.questions.slice();
    questions.splice(index, 1);
    this.props.onChange(questions);
  }
  add(
    faq = {
      question: '',
      answer: '',
    },
  ) {
    let questions = this.props.questions.slice();
    questions.push(faq);
    this.props.onChange(questions);
  }
  handleSuggestionSelect = (faq: QA) => {
    this.add(faq);
    this.toggleSuggestionModal(false);
  };
  toggleSuggestionModal = (value: boolean) => {
    this.setState({ faqSuggestionsModal: value });
  };
  render() {
    const enableFaqSuggestions = this.props.faqSuggestions?.length > 0;

    let items = [];
    if (this.props.questions) {
      items = this.props.questions.map((q, i) => {
        return (
          <FaqItem
            question={q.question}
            answer={q.answer}
            key={i}
            total={this.props.questions.length}
            index={i}
            onChange={this.onChange}
            onMoveUp={this.moveUp}
            onMoveDown={this.moveDown}
            onDelete={this.delete}
            questionPlaceholder={
              this.props.questionPlaceholder
                ? this.props.questionPlaceholder
                : 'Question?'
            }
            answerPlaceholder={
              this.props.answerPlaceholder
                ? this.props.answerPlaceholder
                : 'Answer.'
            }
            isSalesPageBuilder={this.props.isSalesPageBuilder}
            tree={
              this.props.tree && this.props.tree[i] ? this.props.tree[i] : null
            }
          />
        );
      });
    }

    const canAddFaq =
      !this.props.maxItems || this.props.maxItems > this.state.items.length;

    return (
      <section>
        {this.state.faqSuggestionsModal && (
          <FaqSuggestionsModal
            faqSuggestions={this.props.faqSuggestions}
            onClose={() => this.toggleSuggestionModal(false)}
            onSuggestionSelect={this.handleSuggestionSelect}
          />
        )}
        {items}

        <div className="flex gap-4">
          {canAddFaq && (
            <Button onClick={this.add}>
              {this.props.addLabel ? this.props.addLabel : '+ Add'}
            </Button>
          )}
          {canAddFaq && enableFaqSuggestions && (
            <Button
              onClick={() => this.toggleSuggestionModal(true)}
              variant="gray"
            >
              Show FAQ suggestions
            </Button>
          )}
        </div>
      </section>
    );
  }
}

function FaqSuggestionsModal({ faqSuggestions, onClose, onSuggestionSelect }) {
  return (
    <Modal
      isOpen={true}
      onRequestClose={onClose}
      style={{
        overlay: {
          zIndex: 100,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
        content: {
          padding: '30px',
          backgroundColor: 'white',
          position: 'relative',
          maxWidth: '1000px',
          maxHeight: '80vh',
          overflowY: 'scroll',
          height: 'fit-content',
          borderRadius: '20px',
        },
      }}
    >
      <a
        onClick={onClose}
        className="absolute right-8 text-3xl text-black hover:text-primary hover:cursor-pointer"
      >
        <FontAwesomeIcon icon={faClose} />
      </a>
      <h2 className="mb-10">FAQ suggestions</h2>
      {faqSuggestions.map((faq, index) => (
        <FaqSuggestion
          key={index}
          faq={faq}
          onSelect={() => onSuggestionSelect(faq)}
        />
      ))}
    </Modal>
  );
}

function FaqSuggestion({ faq, onSelect }) {
  return (
    <div className="relative mb-5 border-b last:border-b-0">
      <Button className="absolute right-0" onClick={onSelect}>
        Use FAQ
      </Button>
      <div className="text-[17px] font-bold">{faq.question}</div>
      <div className="mt-5 mb-5 text-[15px] leading-[1.5] opacity-80 whitespace-pre-wrap pr-[150px]">
        {faq.answer}
      </div>
    </div>
  );
}

class FaqItem extends React.Component {
  constructor(props) {
    super(props);
    this.changeQuestion = this.changeQuestion.bind(this);
    this.changeAnswer = this.changeAnswer.bind(this);
    this.validate = this.validate.bind(this);
  }
  changeQuestion(ev) {
    this.props.onChange(this.props.index, {
      question: ev.target.value,
      answer: this.props.answer,
    });
  }
  changeAnswer(ev) {
    this.props.onChange(this.props.index, {
      question: this.props.question,
      answer: ev.target.value,
    });
  }
  validate(attribute) {
    if (
      this.props.tree &&
      this.props.tree[attribute] &&
      this.props.tree[attribute].length > 0
    ) {
      return 'invalid';
    }
    return;
  }
  render() {
    let buttons = [];
    if (this.props.index > 0) {
      if (this.props.index < this.props.total - 1) {
        buttons = [
          <a
            className="actionLink icon icon-arrow-up hover:text-primary"
            onClick={() => this.props.onMoveUp(this.props.index)}
          />,
          <a
            className="actionLink icon icon-arrow-down hover:text-primary"
            onClick={() => this.props.onMoveDown(this.props.index)}
          />,
        ];
      } else {
        buttons = [
          <div
            style={{
              display: 'inline-block',
              width: '25px',
              height: '25px',
              marginLeft: '10px',
            }}
          />,
          <a
            className="actionLink icon icon-arrow-up hover:text-primary"
            onClick={() => this.props.onMoveUp(this.props.index)}
          />,
        ];
      }
    } else if (this.props.total === 1) {
      buttons = [];
    } else {
      buttons = [
        <div
          style={{
            display: 'inline-block',
            width: '25px',
            height: '25px',
            marginLeft: '10px',
          }}
        />,
        <a
          className="actionLink icon icon-arrow-down hover:text-primary"
          onClick={() => this.props.onMoveDown(this.props.index)}
        />,
      ];
    }

    return (
      <div className="programEdit">
        <div
          className={`${
            this.props.isSalesPageBuilder
              ? 'flex flex-col max-w-[1000px] items-stretch md:flex-row'
              : 'flex flex-row items-stretch'
          }`}
        >
          <div
            style={{ /*background: '#f00',*/ flexGrow: '10', flexShrink: '10' }}
          >
            <div className="input-holder flex flex-col">
              {this.props.isSalesPageBuilder ? (
                <>
                  <h4>FAQ {this.props.index + 1}</h4>
                  <label>
                    Question
                    <span className={'text-red-500'}>*</span>
                  </label>
                </>
              ) : (
                <label>Question #{this.props.index + 1}</label>
              )}
              <TextField
                type="text"
                onChange={this.changeQuestion}
                value={this.props.question}
                placeholder={this.props.questionPlaceholder}
                inputProps={{ maxLength: 200 }}
                className={this.validate('question')}
              />
            </div>
            <div className="input-holder flex flex-col">
              {this.props.isSalesPageBuilder ? (
                <label>
                  Answer <span className={'text-red-500'}>*</span>
                </label>
              ) : (
                <label>Answer #{this.props.index + 1}</label>
              )}
              <TextField
                multiline
                onChange={this.changeAnswer}
                value={this.props.answer}
                inputProps={{ maxLength: 2000 }}
                placeholder={this.props.answerPlaceholder}
                className={this.validate('answer')}
              />
            </div>
          </div>
          <div
            className="faq-buttons"
            style={{
              /*background: '#0f0',*/ display: 'flex',
              flexGrow: '1',
              flexShrink: '1',
              justifyContent: 'flex-end',
            }}
          >
            {buttons[0]}
            {buttons[1]}
            {this.props.isSalesPageBuilder && this.props.total === 1 ? null : (
              <a
                className="actionLink icon icon-remove hover:text-primary"
                onClick={() => this.props.onDelete(this.props.index)}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Faq;
